import { hookReduxCreator } from "./hook-creator";

const useStockTrades = /** @type { ReturnType<typeof hookReduxCreator<import('../actions/realtimeAction').TradesData>} */ (hookReduxCreator(state => state.realtime.trades, 'useStockTrades'));

export default useStockTrades;